export default __webpack_public_path__ + "static/media/close.6acb0796.svg";